import(/* webpackMode: "eager", webpackExports: ["default"] */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/workspace/components/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/HolographicCapabilities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/Industries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/MissionControl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/SelectedWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/Technologies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/ui/InteractiveServiceBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn"] */ "/workspace/components/ui/motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/ui/PerspectiveGrid.tsx");
